import { Controller } from "@hotwired/stimulus"
let debounce = require("lodash/debounce");

export default class extends Controller {
  static targets = [ "results" ]
  // static values = {
  //   quantity: { type: Number, default: 1 },
  //   min: { type: Number, default: 1 },
  //   max: { type: Number, default: 20 },
  //   price: { type: Number, default: 0 },
  //   newRecord: { type: Boolean, default: true }
  // }
  query = "";

  connect() {
    console.log("order address lookup controller");
    this._search = debounce(this._search, 500).bind(this);
    // show loading indicator
  }

  search(event) {
    this.query = event.target.value.toLowerCase();
    this._search()
  }

  _search() {
    console.log("address search", this.query);

    this.resultsTarget.innerHTML = '<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>'

    fetch(`/order/address/lookup?query=${this.query}`).then(response => response.text()).then( html => {
      this.resultsTarget.innerHTML = html;
    }).catch(function(error) {
      console.error("address lookup error", error);
    })

    // this.locationTargets.forEach(element => {
    //   var match = element.dataset["nameAddress"].includes(this.query);
    //   element.hidden = !match;
    // });
  }

}
